import type { FC } from "react";
import { useLocation } from "react-router-dom";

import { ErrorBoundary } from "@components/errors/ErrorBoundary/ErrorBoundary";
import { Header } from "@components/Header/Header";
import { useGroupsDropdown } from "@hooks/useGroupsDropdown";
import { Users } from "@icons";

import classes from "./AccessLayout.module.css";
import type { AccessLayoutProps } from "./AccessLayout.types";

export const AccessLayout: FC<AccessLayoutProps> = ({ children }) => {
  const { pathname } = useLocation();

  const { groupsDropdownOptions, groupsOnDropdownChange, groupsDropdownValue } =
    useGroupsDropdown();

  return (
    <ErrorBoundary pathname={pathname}>
      <Header
        breadcrumbPaths={[
          {
            path: "",
            pathName: "Mes collaborateur·rice·s",
            pathIcon: Users,
          },
        ]}
        dropdownOptions={groupsDropdownOptions}
        dropdownValue={groupsDropdownValue}
        onDropdownChange={(select) => groupsOnDropdownChange(select)}
      />
      <div className={classes.content}>{children}</div>
    </ErrorBoundary>
  );
};
